// extracted by mini-css-extract-plugin
export default {"checkboxStyle":"checkbox_checkboxStyle__R9jJ+","checkbox":"checkbox_checkbox__Ilsfh","checkmark":"checkbox_checkmark__Ll7+e"};